/* Progressive tabs. Every panel and product link remains available without JS. */
(() => {
 if (customElements.get('pp-home-tabs')) return;
 customElements.define('pp-home-tabs', class extends HTMLElement {
  connectedCallback() {
   if (this.dataset.ready) return;
   this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
   this.panels = Array.from(this.querySelectorAll('[data-pp-home-panel]'));
   if (!this.tabs.length || this.tabs.length !== this.panels.length) return;
   this.abort = new AbortController();
   const options = {signal:this.abort.signal};
   this.tabs.forEach((tab,index) => {
    const panel = this.panels[index];
    panel.setAttribute('role','tabpanel');
    panel.setAttribute('aria-labelledby',tab.id);
    panel.tabIndex = 0;
    tab.addEventListener('click',()=>this.select(index),options);
    tab.addEventListener('keydown',event=>{
     let next;
     if (event.key==='ArrowRight') next=(index+1)%this.tabs.length;
     if (event.key==='ArrowLeft') next=(index-1+this.tabs.length)%this.tabs.length;
     if (event.key==='Home') next=0;
     if (event.key==='End') next=this.tabs.length-1;
     if (next===undefined) return;
     event.preventDefault();this.select(next);this.tabs[next].focus();
    },options);
   });
   this.querySelector('[role="tablist"]').hidden=false;
   this.dataset.ready='true';this.select(0);
   this.addEventListener('shopify:block:select',event=>{
    const index=this.tabs.findIndex(tab=>tab===event.target || tab.contains(event.target));
    if(index>=0)this.select(index);
   },options);
  }
  select(index) {
   this.tabs.forEach((tab,i)=>{
    const active=i===index;
    tab.setAttribute('aria-selected',String(active));tab.tabIndex=active?0:-1;
    this.panels[i].hidden=!active;
   });
  }
  disconnectedCallback() {this.abort?.abort();delete this.dataset.ready;}
 });
})();
